<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="12" fill="url(#paint0_linear)"/>
<circle cx="16" cy="16" r="11.5" stroke="white" stroke-opacity="0.16"/>
<defs>
<linearGradient id="paint0_linear" x1="16" y1="4" x2="16" y2="35.8" gradientUnits="userSpaceOnUse">
<stop stop-color="white" stop-opacity="0.52"/>
<stop offset="0.802083" stop-color="white" stop-opacity="0"/>
</linearGradient>
</defs>
</svg>
